import React from "react";
import { Section, sectionSpacingY } from "components/section";
import { Flex, ListItem, UnorderedList, VisuallyHidden } from "@chakra-ui/react";
import { Diptych } from "ui/diptych";
import { useWarehouseCdp } from "contexts/warehouse-cdp-context";
import { DecorativeBackgroundImage } from "components/images";

function WordCloud() {
  const { warehouse } = useWarehouseCdp();

  return (
    <Flex boxSize="100%" overflow="hidden" pos="relative">
      {/* Render the words for SEO, but hide them from the user */}
      <VisuallyHidden>
        <UnorderedList>
          {warehouse.words.map((word) => (
            <ListItem key={word}>{word}</ListItem>
          ))}
        </UnorderedList>
      </VisuallyHidden>
      {/* Render the image visually for users, but hide it from SEO */}
      <DecorativeBackgroundImage src={warehouse.wordImage} style={{ objectFit: "cover" }} />
    </Flex>
  );
}

export function WarehouseWordCloud() {
  const { warehouse } = useWarehouseCdp();

  return (
    <Section my={0} pt={sectionSpacingY}>
      <Diptych
        direction="right"
        size="lg"
        titleAs="h2"
        title={`Supported ${warehouse.name} capabilities`}
        description={`Hightouch supports all the nuanced things about ${warehouse.name} that you already know and love.`}
        media={<WordCloud />}
      />
    </Section>
  );
}
